<template>
  <div class="ppcCenter">
    <!--    <div class="ppcCenterHeader">-->
    <!--      <div class="linkCopierSection">-->
    <!--        -->
    <!--&lt;!&ndash;        <addVersion v-if=" accountView && creative.comment_status == 'account' && (creative.status == 'live' || creative.status == 'draft')" :creative="creative" />&ndash;&gt;-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="imageInfoTop">
      <PPCImageInfo id="imageInfocontainer" :accountView="accountView" :board="board" :creative="creative" />

      <KeyboardNavigation />
    </div>
  </div>
</template>

<script>
import PPCImageInfo from './PPCImageInfo';
import KeyboardNavigation from './KeyboardNavigation'
export default {
  props: ['creative', 'accountView', 'board'],
  watch: {
    
    'creative': function () {
      if (document.getElementById('imageInfocontainer')) {
        this.scale = Math.min((document.getElementById('imageInfocontainer').clientHeight - 170) / parseInt(this.creative.height), (document.getElementById('imageInfocontainer').clientWidth) / parseInt(this.creative.width))
      }

    }
  },
  components: {

    PPCImageInfo,
    KeyboardNavigation
  },
  data() {
    return {

      scale: 1
    }
  },
  mounted() {
    if (document.getElementById('imageInfocontainer')) {
      
      this.scale = Math.min((document.getElementById('imageInfocontainer').clientHeight - 170) / parseInt(this.creative.height), (document.getElementById('imageInfocontainer').clientWidth) / parseInt(this.creative.width))
    }
  },
  methods: {
    async refreshBoard(needreselect) {
      return new Promise(resolve => {
        if (this.$parent.refreshBoard)
          this.$parent.refreshBoard(needreselect).then(() => resolve())
      })
    },
    refreshBrand() {
      if (this.$parent.refreshBrand)
        this.$parent.refreshBrand();
    },
    selectCreativeByParentId(parent_id) {
      if (this.$parent.selectCreativeByParentId)
        this.$parent.selectCreativeByParentId(parent_id);
    },
    selectCreativeById(id) {
      if (this.$parent.selectCreativeById)
        this.$parent.selectCreativeById(id);
    },

  }
}
</script>